/**
 * Card — flat clean surface, rounded-card (18px), soft cool shadow (§2, §4).
 * Content cards are NOT glass (glass is for the tab bar only, §4/§5).
 */
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Card({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-card border border-border bg-surface p-4 shadow-card",
        className,
      )}
      {...props}
    />
  );
}
